export const NOTES_KEY = 'notes';

export interface Note {
  listingId: string;
  createdAt: number;
  updatedAt: number;
  text: string;
}

let notes: Record<string, Note> | null = null;

export function getNotes(): Record<string, Note> {
  if (notes) return notes;

  const notesString = localStorage.getItem(NOTES_KEY);
  notes = notesString ? (JSON.parse(notesString) as Record<string, Note>) : {};

  return notes;
}

export function clearCachedNotes(): void {
  notes = null;
}

export function getNote(listingId: string): Note | undefined {
  const currentNotes = getNotes();
  return currentNotes[listingId];
}

export function setNote(listingId: string, text: string): void {
  const currentNotes = getNotes();
  const date = Date.now();

  if (currentNotes[listingId]) {
    currentNotes[listingId].updatedAt = date;
    currentNotes[listingId].text = text;
  } else {
    currentNotes[listingId] = {
      createdAt: date,
      updatedAt: date,
      listingId: listingId,
      text: text,
    };
  }

  localStorage.setItem(NOTES_KEY, JSON.stringify(currentNotes));
}

export function removeNote(listingId: string): void {
  const currentNotes = getNotes();
  if (currentNotes[listingId]) {
    const { [listingId]: _, ...rest } = currentNotes;
    notes = rest; // Update the notes variable with the rest of the notes
    localStorage.setItem(NOTES_KEY, JSON.stringify(notes));
  }
}
